export default function WarningIcon({
  color = 'currentColor',
  size = 24,
}: { color?: string; size?: number } = {}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 69 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M66.3984 45.5407L44.8402 7.20928C42.223 2.56087 38.4735 0 34.2773 0C30.0806 0 26.3286 2.56087 23.7129 7.20928L2.15061 45.5407C-0.447932 50.1593 -0.700374 54.7227 1.44078 58.385C3.58354 62.0494 7.68681 64.0678 12.993 64.0678H55.5585C60.8652 64.0678 64.9674 62.051 67.1085 58.385C69.2518 54.7227 68.9994 50.1609 66.3987 45.5407H66.3984ZM62.2808 55.5633C61.1847 57.4409 58.7971 58.4737 55.5598 58.4737H12.9943C9.75705 58.4737 7.36946 57.4408 6.2717 55.5616C5.17508 53.6861 5.44232 51.1019 7.02721 48.2838L28.5908 9.95376C29.5063 8.32527 31.463 5.59493 34.2789 5.59493C37.0928 5.59493 39.05 8.32527 39.9665 9.95267L61.526 48.2841C63.1088 51.1011 63.3787 53.6864 62.2821 55.563L62.2808 55.5633Z"
        fill={color}
      />
      <path
        d="M34.2768 44.9208C31.7558 44.9208 29.7061 46.9721 29.7061 49.4953C29.7061 52.0158 31.7558 54.0646 34.2768 54.0646C36.7962 54.0646 38.846 52.0159 38.846 49.4953C38.846 46.9716 36.7969 44.9208 34.2768 44.9208Z"
        fill={color}
      />
      <path
        d="M31.1932 38.0816L31.2278 38.6378C31.265 40.287 32.6177 41.6174 34.2769 41.6174C35.9579 41.6174 37.3261 40.2503 37.325 38.6256L37.3245 38.5969C37.6518 33.6659 38.479 21.0974 38.5002 20.6757L38.5034 20.5758C38.5002 18.2833 36.6062 16.4174 34.2786 16.4174C31.9488 16.4174 30.0537 18.3126 30.0537 20.6418L30.0574 20.7529C30.0691 20.9611 30.4697 27.0945 31.1934 38.081L31.1932 38.0816Z"
        fill={color}
      />
    </svg>
  );
}
